import axios from 'axios';

import {
  ActiveDeliverySettings,
  ActiveDeliverySettingsConfig,
  DeliveryArea,
  DeliveryAreaPatchData,
  DeliveryAreasData,
} from './types';

const deliverySettingsApi = axios.create({
  baseURL: process.env.DELIVERY_SETTINGS_API_URI,
});

export const getActiveDeliverySettings = (venueId: string): Promise<ActiveDeliverySettings> =>
  deliverySettingsApi
    .get<ActiveDeliverySettings>(`/merchant-admin/venues/${venueId}/delivery-settings`)
    .then(response => response.data);

export const updateActiveDeliverySettings = (venueId: string, settings: ActiveDeliverySettingsConfig): Promise<void> =>
  deliverySettingsApi.put(`/merchant-admin/venues/${venueId}/delivery-settings`, settings);

export const getSelfDeliveryAreas = (venueId: string): Promise<DeliveryArea[]> =>
  deliverySettingsApi
    .get<DeliveryAreasData>(`/merchant-admin/venues/${venueId}/self-delivery/delivery-settings`)
    .then(response => response.data.deliveryAreas);

export const updateSelfDeliveryAreas = (venueId: string, deliveryAreas: DeliveryAreaPatchData[]): Promise<void> =>
  deliverySettingsApi.put(`/merchant-admin/venues/${venueId}/self-delivery/delivery-settings`, { deliveryAreas });

export default deliverySettingsApi;
